import React from 'react';
import {observer} from 'mobx-react';
import {GamingHistoryBox} from "./boxes/gaming-history/gaming-history.box";
import {GamingHistoryType} from "../../services/gaming-history/gaming-history-type";
import {OrbitComponentWithState} from "../base-components/orbit-component-with-state/orbit-component-with-state";
import {IHistoryPaginatorViewModel} from "../../services/gaming-history/models/paginator/history-paginator-view-model.interface";
import {HistoryRecordComponent} from "./record/history-record.component";
import {HistoryFooterComponent} from "./footer/history-footer.component";
import {HistoryHeaderComponent} from "./header/history-header.component";
import {IntersectionSpyComponent} from "../../basic-components/intersection-spy/intersection-spy.component";

interface GamingHistoryComponentProps {
    historyType: GamingHistoryType;
    showMoreDetails: boolean;
    redirectHomeIfUnauthorized: boolean;
}

interface GamingHistoryComponentState {
    paginator: IHistoryPaginatorViewModel | null;
}

export const GamingHistoryComponent = observer(
    class GamingHistoryComponent extends OrbitComponentWithState<GamingHistoryComponentProps, GamingHistoryComponentState> {

        constructor(props: GamingHistoryComponentProps) {
            super(props);
            this.state = {
                paginator: null
            };
        }


        componentDidMount() {
            super.componentDidMount();
            this._initPaginator();
        }

        componentDidUpdate(prevProps: GamingHistoryComponentProps) {
            if(this.props.historyType !== prevProps.historyType) {
                this._initPaginator();
            }
        }

        private _initPaginator() {
            const paginator = this.services.gamingHistory.getGamingHistory(this.props.historyType);
            this.setState({
                paginator: paginator
            }, () => paginator.loadNextPage());
        }


        private _onIntersect = () => {
            if(this.state.paginator.hasMoreRecords) {
                this.state.paginator.loadNextPage();
            }
        }

        render() {

            if(!this.services.user.isAuthorized) {
                if (this.props.redirectHomeIfUnauthorized) {
                    this.services.location.goHome();
                }
                return null;
            }


            if(!this.state.paginator) {
                return null;
            }

            return (
                <GamingHistoryBox>
                    <HistoryHeaderComponent paginator={this.state.paginator}/>
                    {this.state.paginator.records.map(record => <HistoryRecordComponent key={record.ids.map(id => id.text).join()} record={record} showMoreDetails={this.props.showMoreDetails}/>)}
                    <IntersectionSpyComponent onIntersect={this._onIntersect} cyClass={'cy-gaming-history-loading-trigger'}/>
                    <HistoryFooterComponent paginator={this.state.paginator}/>
                </GamingHistoryBox>
            );
        }
    }
);